import { actions } from '../../../services/analytics'

// STEPS.FINISH is the canonical terminal step (wallet path). The Stripe
// hosted-redirect lands on /checkout/success/:sessionId which is mounted
// outside this booking switch (see top-level router). There used to be a
// STEPS.SUCCESS / '/booking/success' route - removed: nothing referenced
// it and the two duplicate terminals confused readers.
export const STEPS = {
  DETAILS: 'details',
  BOOK: 'book', // experiment arm: details + extras + payment on one screen
  SERVICE: 'service',
  EXTRA: 'extra',
  SIGN_IN: 'sign_in',
  CHECKOUT: 'checkout',
  FINISH: 'finish'
}

// The step a visitor may open cold (new tab, ad, WhatsApp or email link) with
// nothing saved: Book & pay picks the wash up from ?service= / ?extra= or from
// the default base. A cold load of anything else under /booking goes there.
// The old four-step screens (details, its alias address, service, extra,
// checkout) were deleted on 12 Oct 2026; their URLs redirect to Book & pay.
export const COLD_ENTRY_STEPS = [STEPS.BOOK]

export const stepNumber = {
  [STEPS.SERVICE]: 0,
  [STEPS.DETAILS]: 1,
  [STEPS.BOOK]: 1,
  [STEPS.EXTRA]: 2,
  [STEPS.SIGN_IN]: 3,
  [STEPS.CHECKOUT]: 3
}

export const BOOKING_ROUTES = {
  [STEPS.DETAILS]: '/booking/details',
  [STEPS.BOOK]: '/booking/book',
  [STEPS.SERVICE]: '/booking/service',
  [STEPS.EXTRA]: '/booking/extra',
  [STEPS.SIGN_IN]: '/booking/sign_in',
  [STEPS.CHECKOUT]: '/booking/checkout',
  [STEPS.FINISH]: '/booking/finish'
}

export const nextStep = {
  [STEPS.SERVICE]: STEPS.DETAILS,
  [STEPS.DETAILS]: STEPS.EXTRA,
  [STEPS.EXTRA]: STEPS.CHECKOUT,
  [STEPS.SIGN_IN]: STEPS.CHECKOUT,
  [STEPS.CHECKOUT]: STEPS.FINISH
}

export const prevStep = {
  [STEPS.SERVICE]: STEPS.SERVICE,
  [STEPS.DETAILS]: STEPS.SERVICE,
  [STEPS.BOOK]: STEPS.SERVICE,
  [STEPS.EXTRA]: STEPS.DETAILS,
  [STEPS.SIGN_IN]: STEPS.EXTRA,
  [STEPS.CHECKOUT]: STEPS.EXTRA
}

export const ANALYTICS_ACTIONS = {
  [STEPS.SERVICE]: actions.bookingStep1,
  [STEPS.DETAILS]: actions.bookingStep2,
  [STEPS.BOOK]: actions.bookingStep2,
  [STEPS.EXTRA]: actions.bookingStep3,
  [STEPS.SIGN_IN]: actions.bookingStepLogin,
  [STEPS.CHECKOUT]: actions.bookingStep4,
  [STEPS.FINISH]: actions.clickPlaceOrder
}

export const ANALYTICS_STEPS = {
  [STEPS.SERVICE]: 1,
  [STEPS.DETAILS]: 2,
  [STEPS.BOOK]: 2,
  [STEPS.EXTRA]: 3,
  [STEPS.SIGN_IN]: 4,
  [STEPS.CHECKOUT]: 5,
  [STEPS.FINISH]: 6
}
